module.exports = "./static/ai_chatbot_entry.2d672152.png";